import classnames from 'classnames';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import React from 'react';

import { EventRequestCategory } from '@/constants/EventRequestCategory.enum';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

const movieBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterFilmLandscape.jpg');
const moviePosterPlaceholder = loadAsset('/images/placeholders/portrait/im-posterFilmPortrait.jpg');
const gamingEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterGamingLandscape.jpg');
const gamingEventPosterPlaceholer = loadAsset('/images/placeholders/portrait/im-gamingEvent.png');
const presentationEventBackdropPlaceholder = loadAsset(
    '/images/placeholders/landscape/im-posterPresentationLandscape.jpg'
);
const presentationEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-presentationEvent.png');
const ideaEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterEventIdeaLandscape.jpg');
const ideaEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-ideaEvent.png');
const businessEventBackdropPlaceholder = loadAsset('/images/placeholders/landscape/im-posterBusinessLandscape.jpg');
const businessEventPosterPlaceholder = loadAsset('/images/placeholders/portrait/im-businessEvent.png');

export type CategorySpecificPosterProps = {
    className?: string;
    category: EventRequestCategory | string;
    type: 'poster' | 'backdrop';
    imageSpecificClass?: string;
};

function CategorySpecificPoster(props: CategorySpecificPosterProps): React.JSX.Element {
    const { className, category, type } = props;
    const t = useTranslations();

    let categorySpecificPoster: string;
    let alt: string;

    switch (category) {
        case EventRequestCategory.MOVIE_SERIES:
            categorySpecificPoster = type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
            alt = t('category-poster.film');
            break;
        case EventRequestCategory.GAMING:
            categorySpecificPoster = type === 'poster' ? gamingEventPosterPlaceholer : gamingEventBackdropPlaceholder;
            alt = t('category-poster.gaming');
            break;
        case EventRequestCategory.PRESENTATION:
            categorySpecificPoster =
                type === 'poster' ? presentationEventPosterPlaceholder : presentationEventBackdropPlaceholder;
            alt = t('category-poster.presentation');
            break;
        case EventRequestCategory.OWN_CONTENT:
            categorySpecificPoster = type === 'poster' ? ideaEventPosterPlaceholder : ideaEventBackdropPlaceholder;
            alt = t('category-poster.own-content');
            break;
        case EventRequestCategory.BUSINESS:
            categorySpecificPoster =
                type === 'poster' ? businessEventPosterPlaceholder : businessEventBackdropPlaceholder;
            alt = t('category-poster.business');
            break;
        case EventRequestCategory.DISCOVER:
            categorySpecificPoster = type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
            alt = t('category-poster.discover');
            break;
        default:
            categorySpecificPoster = type === 'poster' ? moviePosterPlaceholder : movieBackdropPlaceholder;
            alt = t('category-poster.default');
            break;
    }

    return (
        <Image
            className={classnames(className, 'h-full w-full object-cover')}
            src={categorySpecificPoster}
            width={600}
            height={800}
            alt={alt}
        />
    );
}

export default CategorySpecificPoster;
